import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Clipboard from 'stimulus-clipboard';

const application = Application.start()
const context = require.context(".", true, /\.js$/)
application.load(definitionsFromContext(context))
application.register("clipboard", Clipboard)